var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6301 13.0085H23.492C22.8687 13.0088 22.286 12.6995 21.937 12.1831L19.3109 8.31339C18.9606 7.79915 18.3781 7.49208 17.7558 7.49366H9.36923C7.2973 7.49366 5.61768 9.1733 5.61768 11.2452V33.7546C5.61768 35.8265 7.2973 37.5061 9.36923 37.5061H35.6301C37.702 37.5061 39.3816 35.8265 39.3816 33.7546V16.76C39.3816 14.6881 37.702 13.0085 35.6301 13.0085Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61768 18.5234H17.7558C18.3761 18.5231 18.9561 18.2162 19.3053 17.7036L21.9314 13.8301C22.2805 13.3163 22.8614 13.0086 23.4826 13.0085",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationFolder);
export default __webpack_public_path__ + "static/media/navigation-folder.ac5f5f44.svg";
export { ForwardRef as ReactComponent };